import React from 'react';

export const BCTabContainer = ({ title, children }) => (
  <div className="BusinessCentral__tabContainer">
    <h1 className="BusinessCentral__tabContainer__title">{title}</h1>
    {children}
  </div>
);
